module.exports = __webpack_public_path__ + "static/favorites-img-1731307c245015d10f9a28d3fef89eca.png";